import * as React from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import bannerData from './bannerData'
import { Segment, Container, Divider } from 'semantic-ui-react'

const Banner = () => {
  return (
    <Segment vertical inverted textAlign='center' className='masthead'>
      <Divider hidden />
      <Container>
        <Carousel
          infiniteLoop
          useKeyboardArrows
          autoPlay
          emulateTouch
          showStatus={false}
        >
          {bannerData.map((x, i) => (
            <img key={i} src={x} />
          ))}
        </Carousel>
      </Container>
    </Segment>
  )
}

export default Banner
